import { css } from '@emotion/core';
import { Magnetic } from "../../../styles";
import styled from '@emotion/styled';
import Grid from '@material-ui/core/Grid';
export const timeInputBorderRadius = `4px`;
export const miFormControlCore = `
	display: ${Magnetic.formControlCoreDisplay};
	height: ${Magnetic.formControlCoreHeight};
	background-color: ${Magnetic.formControlCoreBackgroundColor};
	border: ${Magnetic.formControlCoreBorder};
	border-radius: ${Magnetic.formControlCoreBorderRadius};
	box-sizing: ${Magnetic.formControlCoreBoxSizing};
	padding: ${Magnetic.formControlCorePadding};
	background-clip: ${Magnetic.formControlCoreBackgroundClip};
	color: ${Magnetic.formControlCoreFontColor};
	min-width: ${Magnetic.formControlCoreMinWidth};
	line-height: ${Magnetic.formControlCoreLineHeight};
	width: ${Magnetic.formControlCoreWidth};
	font-size: ${Magnetic.baseFontSize};
	font-family: ${Magnetic.baseFontFamily};

	&:active, &:focus {
		border: ${Magnetic.formControlCoreBorderActiveFocus};
		outline: ${Magnetic.formControlCoreOutlineActiveFocus};
		box-shadow: ${Magnetic.formControlCoreBoxShadowActiveFocus};
	}

	&::placeholder {
		color: ${Magnetic.formControlCorePlaceholderFontColor};
		opacity: 1;
	}

	&[disabled], &[disabled]:hover, &[disabled]:active {
        border: ${Magnetic.formControlCoreBorderDisabled};
        color: ${Magnetic.disabledFontColor};
	    background-color: ${Magnetic.formControlCoreBackgroundColorDisabled};
	    box-shadow: ${Magnetic.formControlCoreBoxShadowDisabled};
	    pointer-events: ${Magnetic.formControlCorePointerEventsDisabled};
	}

	&:required {
		&:valid {
			background-image: ${Magnetic.formControlCoreBackgroundImageRequiredValid};
		}

		&:disabled {
			background-image: ${Magnetic.formControlCoreBackgroundImageRequiredDisabled};
		}

        &:focus {
                background-image: ${Magnetic.formControlCoreBackgroundImageRequiredFocus};
        }

		background-repeat: ${Magnetic.formControlCoreBackgroundRepeatRequired};
		background-position: ${Magnetic.formControlCoreBackgroundPositionRequired};
		background-position-y: ${Magnetic.formControlCoreBackgroundPositionXRequired};
		background-position-x: ${Magnetic.formControlCoreBackgroundPositionXRequired};
		background-image: ${Magnetic.formControlCoreBackgroundImageRequired};
    }
	::placeholder {
		color: ${Magnetic.formControlCorePlaceholderFontColor};
	}
`;
export const errorTextBoxCss = css `
	border-color: ${Magnetic.validationErrorColor};
`;
export const erroMessageCss = css `
	color: ${Magnetic.colorWhite};
	padding: ${Magnetic.spacer04};
	font-size: ${Magnetic.fontSize12};
`;
export const errorContainer = css `
	background-color: ${Magnetic.validationErrorColor};
	border-radius: ${Magnetic.baseBorderRadius};
`;
export const warningMessageCss = css `
	color: ${Magnetic.validationErrorColor};
	padding-left: 0;
	padding-right: 0;
	padding-top: ${Magnetic.spacer04};
	padding-bottom: ${Magnetic.spacer04};
	line-height: 16px;
`;
export const warningIconCss = css `
	padding-right: ${Magnetic.spacer04};
`;
export const StyledTextContainer = styled('div') `
	display: inline-block;
	position: relative;
	overflow: hidden;
`;
export const StyledClearButton = styled('span') `
	position: absolute;
	top: 12px;
	right: 10px;
	color: ${Magnetic.colorNeutral30};
    cursor: ${Magnetic.buttonBaseCursor};
    display ${(props) => (props.shouldShowIcon ? '' : 'none')};
    font-size: ${Magnetic.fontSize12}
`;
export const TextAreaHeadingSection = styled(Grid) `
	text-align: left;
	line-height: ${Magnetic.formControlCoreHeight};
	font-weight: ${Magnetic.fontWeightSemibold};
	font-size: ${Magnetic.fontSize14};
	width: ${(props) => props.width};
`;
export const RightControlsSectionGrid = styled(Grid) `
	text-align: right;
	width: ${(props) => props.width};
`;
export const StyledSpaceBarSpan = styled('span') `
	margin: 0 ${Magnetic.spacer16} 0 ${Magnetic.spacer04};
	border-left: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorNeutral30};
	margin-bottom: ${Magnetic.spacer04};
	height: 20px;
`;
export const StyledCurrencyInput = styled('input') `
	${miFormControlCore}
	transition: all 150ms;
	position: relative;
	height: 100%;
	text-align: right;
	padding-left: ${(props) => props.isCurrencySymbolAtEnd ? '0' : Magnetic.spacer16};
	padding-right: ${(props) => props.isCurrencySymbolAtEnd
    ? props.currencySymbolLength > 1
        ? `${props.currencySymbolLength + bufferCharLengthForEdgeCases}ch`
        : Magnetic.spacer16
    : Magnetic.spacer04};
	&:disabled {
		background-color: ${Magnetic.formControlCoreBackgroundColorDisabled};
	}

	&:valid {
		border: ${props => !props.isValid && Magnetic.formControlCoreBorderInvalid};
		box-shadow: ${props => !props.isValid && Magnetic.formControlCoreBoxShadowInvalid};

		&:active,
		&:focus {
			border: ${Magnetic.formControlCoreBorderActiveFocus};
			outline: ${Magnetic.formControlCoreOutlineActiveFocus};
			box-shadow: ${Magnetic.formControlCoreBoxShadowActiveFocus};
		}
	}
`;
const bufferCharLengthForEdgeCases = 1;
const perCharacterWidthForIE = 1.34;
export const StyledCurrencyInputContainer = styled('div') `
	height: ${Magnetic.formControlCoreHeight};
	border-radius: ${Magnetic.formControlCoreBorderRadius};
	color: ${Magnetic.formControlCoreFontColor};
	min-width: ${Magnetic.formControlCoreMinWidth};
	font-size: ${Magnetic.baseFontSize};
	font-family: ${Magnetic.baseFontFamily};
	background-color: ${Magnetic.formControlCoreBackgroundColor};
	position: relative;
	transition: all 150ms;
	line-height: 37px;
	width: ${props => `${props.allowedCharacterLength + bufferCharLengthForEdgeCases}ch`};
	&& {
		/* IE11 target browser code */
		@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) && {
			width: ${props => `${props.allowedCharacterLength * perCharacterWidthForIE +
    bufferCharLengthForEdgeCases}ch`};
		}
	}
`;
export const StyledCurrencySymbol = styled('span') `
	position: absolute;
	z-index: 1;
	left: ${(props) => (props.isCurrencySymbolAtEnd ? `auto` : '0')};
	right: ${(props) => (props.isCurrencySymbolAtEnd ? '0' : 'auto')};
	color: ${(props) => props.isDisabled ? Magnetic.disabledFontColor : ''};
	padding-left: ${(props) => props.isInputRequired && !props.isCurrencySymbolAtEnd ? Magnetic.spacer12 : Magnetic.spacer04};
	padding-right: ${Magnetic.spacer04};
`;
export const StyledDropZoneContainer = styled('div') `
	outline: none;
	width: 100%;
	height: 100%;
`;
export const StyledValidatedInputContainer = styled('span') `
	${miFormControlCore}
	position: relative;
	padding: 0;
	transition: all 150ms;

	&:focus-within {
		border: 1px solid ${Magnetic.colorBrand40};
		box-shadow: inset 0 0 0 1px ${Magnetic.colorBrand40};
	}
	&:hover {
		border: 1px solid ${Magnetic.colorBrand40};
	}
	& > div {
		display: flex;
		width: 100%;
	}
`;
export const StyledValidatedInputDiv = styled('div') `
	height: ${Magnetic.formControlCoreHeight};
	width: fit-content;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
export const StyledValidatedInputElementDiv = styled('div') `
	padding: ${Magnetic.spacer08} 0 ${Magnetic.spacer08} ${Magnetic.spacer08};
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;

	& input {
		position: relative;
		border: none;
		width: 100%; // fill parent
		height: 100%;

		&:focus {
			outline: none;
		}
		&:hover {
			border: 0px;
		}
		&:disabled {
			background-color: ${Magnetic.formControlCoreBackgroundColorDisabled};
		}
	}
`;
export const StyledValidatedInputGrid = styled(Grid) `
	width: 100%;
`;
export const ControlInputError = css `
	border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.validationErrorColor};
	box-shadow: inset 0 0 0 ${Magnetic.baseBorderWidth} ${Magnetic.validationErrorColor};
`;
export const StyledTimeInput = styled('input') `
	border: none;
	outline: none;
	background: transparent;
	font-size: ${Magnetic.fontSize14};
	font-family: ${Magnetic.baseFontFamily};
	color: ${Magnetic.baseFontColor};
	padding: 0;
	flex: 1;
	min-width: 0;

	&::placeholder {
		color: ${Magnetic.colorNeutral30};
		opacity: 1;
		font-size: ${Magnetic.fontSize14};
		font-family: ${Magnetic.baseFontFamily};
	}

	&:disabled {
		color: ${Magnetic.disabledFontColor};
		background: transparent;
	}
`;
export const StyledClearIcon = styled('span') `
	display: inline-flex;
	align-items: center;
	margin-left: auto;
	padding-left: ${Magnetic.spacer04};
	color: ${Magnetic.colorNeutral30};
	cursor: ${Magnetic.buttonBaseCursor};
	font-size: ${Magnetic.fontSize12};
	line-height: 1;
	flex-shrink: 0;
`;
export const StyledTimeInputContainer = styled('div') `
	width: inherit;
	display: inline-flex;
	align-items: center;
	position: relative;
	padding: ${Magnetic.spacer08} ${Magnetic.spacer12};
	border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorNeutral40};
	border-radius: ${timeInputBorderRadius};
	background-color: ${Magnetic.formControlCoreBackgroundColor};
	box-sizing: border-box;

	&:focus-within {
		border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorBrand40};
		box-shadow: inset 0 0 0 ${Magnetic.baseBorderWidth} ${Magnetic.colorBrand40};
	}
	&:hover {
		border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorBrand40};
	}
`;
//# sourceMappingURL=Input.styles.js.map